import React, { forwardRef } from 'react';

interface ShareArrowProps {
  classes?: string;
  style?: React.CSSProperties;
  forwardRef?: React.RefObject<HTMLElement>;
}

export const ShareArrow = forwardRef<HTMLElement, ShareArrowProps>(({ classes, style = {}, forwardRef: _ }, ref) => {
  return (
    <i ref={ref} className={`fa-solid fa-arrow-up-from-bracket ${classes || ''}`} style={style}></i>
  );
});

ShareArrow.displayName = 'ShareArrow';
